import { borderRadius, margin, width } from "@mui/system"

export const useReportPageStyles = () => {
return {
    container: {
    marginTop: '1rem',
    width: '82%',
    background: '#fff',
    height: 'auto',
    minHeight: '98vh',
    boxShadow: '20px 0 20px 20px rgba(222, 222, 222, 0.5)',
    borderRadius: '1rem',
    },
    header: {
     
        backgroundColor: '#fff',
        alignItems: 'center',
        width: '100%',
      },
    title: {
        fontSize: '1.1rem',
        fontWeight: 500,
        width: '100%',
    },
    headings: {
        display: 'flex',
        backgroundColor: '#f3f6f9',
        alignItems: 'center',
        paddingTop: '1rem',
        paddingBottom: '1rem',
        marginLeft: '1.2rem',
        marginRight: '1.2rem',
       
        borderRadius: '0.5rem'
    },
    rowItem: {
        display: 'flex',
        height:'6rem',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center'
    }

}
}
